export default "__VITE_ASSET__R5P2y6rE__"